/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { css, cx } from "@panda/css";
import { flex } from "@panda/patterns";
import { Box } from "@panda/jsx";

import { Category, CategoryProps } from "./Category.organism";
import React from "react";

const cardsStyle: string = cx(
	"learn-cards",
	flex({ flexWrap: "wrap" }),
	css({
		w: "full",
		h: "full",
		rowGap: {
			base: "eds.dimension.48",
			lgDown: "eds.dimension.40",
		},
		columnGap: "eds.dimension.16",
		"& .learn-category.learn-category-count-3": { flex: "1 0 70%", maxWidth: "75%" },
		"& .learn-category.learn-category-count-1": { flex: "1 0 20%", maxWidth: "25%" },
		"& .learn-category.learn-category-count-4": { flex: "0 0 100%" },
		"& .learn-category:nth-child(1):nth-last-child(1)": { flex: "0 0 100%", maxWidth: "none" },
		xlDown: {
			flexDir: "column",
			flexWrap: "nowrap",
			"& .learn-category.learn-category-count-3": { flex: "1 0 0%", maxWidth: "none" },
			"& .learn-category.learn-category-count-1": { flex: "0 1 0%", maxWidth: "none" },
			"& .learn-category.learn-category-count-4": { flex: "1 0 0%" },
		},
	}),
);

export type CategoriesProps = {
	activeTab?: string | null;
	applicationFamily?: string | null;
	categories?: CategoryProps[];
};

export function Categories({ categories = [], activeTab, applicationFamily }: CategoriesProps): React.JSX.Element {
	return (
		<Box className={cardsStyle}>
			{// Assigned a default value to cards so it will never be null
			categories?.map((category, i) => (
				<Category key={`category-${i}`} {...category} activeTab={activeTab} applicationFamily={applicationFamily} />
			))}
		</Box>
	);
}
